import styles from './DismissButton.module.scss';

const DismissButton = ({ onClick }) => (
  <span onClick={onClick}>
    <span>
      <svg
        className={styles.playlistPlaybarDismiss}
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.06 10l4.597-4.596a.749.749 0 1 0-1.061-1.06L10 8.938 5.404 4.343a.749.749 0 1 0-1.06 1.061L8.938 10l-4.596 4.596a.749.749 0 1 0 1.061 1.06L10 11.062l4.596 4.596a.749.749 0 1 0 1.06-1.061L11.062 10z"
          fill="#ffffff"
        />
      </svg>
    </span>
  </span>
);

export default DismissButton;
